// src/Logout.js
import React from "react";

const Logout = () => {
  const handleLogout = () => {
    alert("Logged out successfully!");
  };

  return (
    <div className="container mt-5">
      <h2>Logout</h2>
      <button className="btn btn-danger" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
};

export default Logout;
